import { render, staticRenderFns } from "./LookingForUser.vue?vue&type=template&id=55fd6316&"
import script from "./LookingForUser.vue?vue&type=script&lang=js&"
export * from "./LookingForUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports